import styled, { css, useTheme } from 'styled-components'
import translate from '@i18n'

import useAuthentication from '@hooks/useAuthentication'
import useUser from '@hooks/useUser'

import IconButton from '@components/Buttons/IconButton'
import FollowMyTeamSportCompetitorsList from './FollowMyTeamSportCompetitorsList'

const Container = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing16};
  `}
`

const Header = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
      colors: { strokeDefaultDisabled },
      typography: {
        headings: {
          small: { bundledCSS: headingSmallCSS },
        },
      },
    },
  }) => css`
    height: 48px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 ${spacing16};
    border-bottom: 1px solid ${strokeDefaultDisabled};

    margin: 0 5px;

    ${headingSmallCSS}
  `}
`

const StyledIconButton = styled(IconButton)`
  position: absolute;
  right: 16px;
`

const LoginMessage = styled.div`
  ${({
    theme: {
      colors: { textDefault },
      spacing: { spacing16 },
      typography: {
        catchword: {
          medium2: { bundledCSS: catchwordMedium2CSS },
        },
      },
    },
  }) => css`
    color: ${textDefault};
    padding: 0 ${spacing16};
    ${catchwordMedium2CSS}
  `}
`

const StyledLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`

const FollowMyTeamSelectTeam = ({ onClose }: { onClose: () => void }) => {
  const user = useUser()
  const { login } = useAuthentication()
  const theme = useTheme()

  const onLogin = () => login({ prefix: 'FMT', loginCase: 'email_only' })

  return (
    <Container>
      <Header>
        {translate('followMyTeam.selectTeam')}
        <StyledIconButton
          ariaLabel={translate('close')}
          buttonSize={48}
          onClick={onClose}
          iconName="xmark-large"
          iconSize={24}
          iconColor={theme.colors.iconDefault}
        />
      </Header>
      {!user && (
        <LoginMessage>
          {translate('followMyTeam.alreadyAdded')}{' '}
          <StyledLink onClick={onLogin}>
            {translate('followMyTeam.login')}
          </StyledLink>
        </LoginMessage>
      )}
      <FollowMyTeamSportCompetitorsList />
    </Container>
  )
}

export default FollowMyTeamSelectTeam
